import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = self.customSetting.VendorLicenseController;
const getController = self.customSetting.getVendorLicense;
const postController = self.customSetting.postVendorLicense;

export default {
  // 3-14
  getLicenseFormInfo: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryInsData`)
        .then((res) => {
          context.commit("GET_LICENSEFORM_INFO", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addLicenseInfo: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsData`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 3-15
  getAllLicenses: () => {
    return axios.get(`${baseApi}/${getController}/QryAllLicenses`);
  },
  addExtendLicense: (context, data) => {
    return axios.post(`${baseApi}/${postController}/ExtendLicense`, data);
  },
  DeleteLicense: (context, data) => {
    return axios.post(`${baseApi}/${postController}/DeleteLicense`, data);
  },
};
